import TargetsProduct from './TargetsProductPage';

export default TargetsProduct;
